// extracted by mini-css-extract-plugin
export var container = "GiftConfirmation-module__container___eilee";
export var header = "GiftConfirmation-module__header___vMXqZ";
export var label = "GiftConfirmation-module__label___1jTCY";